var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1b1040cdf9139265915c1033908f9b4e53dd51d8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["keune@ask-phill"]={id:"1b1040cdf9139265915c1033908f9b4e53dd51d8"};
      